// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".operations-table th[data-v-b72a9fa2] {\n  width: 85px;\n  min-width: 85px;\n  height: 44px;\n}\n", ""]);
// Exports
module.exports = exports;
